/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ObjectQueryModel {

        private currentTreeItem: models.TreeConfigurationItem;
        private systemLevel: Wars.Domain.Model.SystemLevel;
        private processConfigurationId: string;
        private newObjectQueryName = "";
        private existingObjectQueries: Array<Wars.Domain.Model.ObjectQuery>;
        private existingCodes: Array<Wars.Domain.Model.Codes.CodeGroup>;
        private showOnTree: string;
        private displayTree: boolean;

        public constructor(
            private scope: angular.IScope,
            private qService: angular.IQService,
            private growlService: angular.growl.IGrowlService,
            private $routeParams: angular.route.IRouteParamsService,
            private systemLevelService: services.SystemLevelService,
            private treeService: services.TreeService,
            private objectQueryService: services.ObjectQueryService) {
            var self = this;
            self.existingObjectQueries = [];
            self.processConfigurationId = $routeParams["id"];
            objectQueryService.loadConfig(self.processConfigurationId).then(() => {
                self.loadAllObjectQueries();
            });
            (<any>scope).getSelectedNode = (data: models.TreeConfigurationItem) => {
                console.info(data);
                self.currentTreeItem = data;
            }
            if (self.processConfigurationId) {
                self.showOnTree = "Process System.Constants System.Calculations"; //.Reporting
            } else {
                self.showOnTree = "System";
            }
            self.displayTree = true;
        }
        
        addNewObjectQuery() {
            var self = this;
            var newObjectQuery = self.objectQueryService.createNewObjectQuery();
            self.objectQueryService.getCustomTransformers()
                .then((result) => {
                    (<any>newObjectQuery).customTransformers = result;
                });
            newObjectQuery.name = self.newObjectQueryName;
            if (self.processConfigurationId) {
                newObjectQuery.processConfiguration_id = self.processConfigurationId;
                self.saveNewObjectQuery(newObjectQuery);
            } else {
                if (self.systemLevel == null) {
                    self.systemLevelService.getSystemLevel().then((systemLevel) => {
                        self.systemLevel = systemLevel;
                        newObjectQuery.systemLevel_id = self.systemLevel.id;
                        self.saveNewObjectQuery(newObjectQuery);
                    }); 
                }
            }
        }

        addNewProjection(objectQuery: Wars.Domain.Model.ObjectQuery) {
            var self = this;
            self.objectQueryService.createNewObjectQueryProjection(objectQuery, self.processConfigurationId != null);
        }

        getTreeItemName(treeItem: Wars.Domain.Model.TreeItem) {
            var self = this;
            if (treeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.TimeTracker) {
                return `[${self.treeService.getDisplayName(treeItem) }]`;
            }
            return `[${self.treeService.getParentDisplayName(treeItem)}] [${self.treeService.getDisplayName(treeItem)}]`;
        }
        
        onDragOverProjection($event: angular.IAngularEvent, projection: models.ObjectQueryProjection) {
            //TODO - Remove if not needed
        }

        onDropProjection($event: angular.IAngularEvent, projection: models.ObjectQueryProjection) {
            var self = this;
            var droppedTreeItem = self.treeService.getTreeConfigurationItem();
            //allow report (indexed form fields and variables) and calculations as projections
            if (droppedTreeItem.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.FormField
                && droppedTreeItem.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.Variable
                && droppedTreeItem.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.Calculation
                && droppedTreeItem.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.TimeTracker) {
                self.growlService.error("Only a form field, system variable, or calculation can be dropped here.");
                return;
            }
            var treeItem = self.treeService.createTreeItemFromItemDropped();
            if (droppedTreeItem.treeItemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.TimeTracker) {
                if (treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Document ||
                    treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Feature ||
                    treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.List ||
                    treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.MultiSelectState ||
                    treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.MultiSelectStatus ||
                    treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.None ||
                    treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Object ||
                    treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.ScheduledResource ||
                    treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.State ||
                    treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Status ||
                    treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.TimeDuration ||
                    treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.TimeSpan ||
                    treeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.User) {
                    self.growlService.error("This variable type is not supported in Object Queries.");
                    self.objectQueryService.rejectChanges();
                    return;
                }    
            }
            projection.reportDataTreeItem = treeItem;
            self.objectQueryService.onObjectQueryModified(projection.myObjectQuery);
            projection.alias = "";
            if (self.objectQueryService.isAggregateQuery(projection.myObjectQuery)) {
                projection.projectionType = Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group;
            }
            self.filterValidProjectionTypes(projection.myObjectQuery);
            self.save(null);
        }

        propertyTypeChange(projection: models.ObjectQueryProjection) {
            var self = this;
            if (projection.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property) {
                projection.reportDataTreeItem = null;
                projection.reportDataTreeItem_id = null;
            }
            if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment ||
                projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation ||
                projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory ||
                projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                if (!self.extensionPropertyIsValid(projection)) {
                    if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment) {
                        projection.reportDataSubTableColumnName = "ClaimDefinitionUniqueIdentifier";
                        projection.reportDataSubTableSystemColumnName = "SystemClaimGroupId";
                    }
                    if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation) {
                        projection.reportDataSubTableColumnName = "ReviewConfigurationUniqueId";
                        projection.reportDataSubTableSystemColumnName = "SystemReviewGroupId";
                    }
                    if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory) {
                        projection.reportDataSubTableColumnName = "ProcessLevelStatusUniqueIdentifier";
                        projection.reportDataSubTableSystemColumnName = "SystemLevelStatusUniqueIdentifier";
                    }
                    if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                        projection.reportDataSubTableColumnName = "ReviewConfigurationUniqueId";
                        projection.reportDataSubTableSystemColumnName = "SystemReviewGroupId";
                    }
                }
            } else {
                projection.reportDataSubTableSystemColumnName = null;
                projection.reportDataSubTableColumnName = null;
            }
            self.save(() => {
                self.filterValidPropertyTypes(projection.myObjectQuery);
                self.filterValidProjectionTypes(projection.myObjectQuery);
            });
        }

        private extensionPropertyIsValid(projection: models.ObjectQueryProjection): boolean {
            if (projection.reportDataSubTableColumnName == null) {
                return false;
            } else {
                if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment) {
                    return Enumerable.from(projection.assignmentQueryMap.columns).any(i => i.column === projection.reportDataSubTableColumnName);
                }
                if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation) {
                    return Enumerable.from(projection.reviewInformationQueryMap.columns).any(i => i.column === projection.reportDataSubTableColumnName);
                }
                if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory) {
                    return Enumerable.from(projection.statusHistoryQueryMap.columns).any(i => i.column === projection.reportDataSubTableColumnName);
                }
                if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                    return Enumerable.from(projection.commentInformationQueryMap.columns).any(i => i.column === projection.reportDataSubTableColumnName);
                }
            }
            return false;
        }

        projectionTypeChange(projection: models.ObjectQueryProjection) {
            var self = this;
            var objectQuery = projection.myObjectQuery;
            self.filterValidProjectionTypes(objectQuery);
            self.save(null);
        }

        private getValidAliasNameFromString(name: string): string {
            name = name.trim();
            if (!isNaN(parseInt(name.charAt(0), 10))) {
                name = "_" + name;
            } else {
                name = name.charAt(0).toLowerCase() + name.slice(1);    
            }
            return name.replace(/[^A-Za-z0-9\_]/g, "");
        }

        setDefaultAliasName(projection: models.ObjectQueryProjection, autoSave: boolean) {
            var self = this;
            if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.RowId) {
                projection.alias = "_Id";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId) {
                projection.alias = "_ProcessId";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessType) {
                projection.alias = "_ProcessType";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessSubType) {
                projection.alias = "_ProcessSubType";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.State) {
                projection.alias = "_State";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedBy) {
                projection.alias = "_StateUpdatedBy";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedDate) {
                projection.alias = "_StateUpdatedDate";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Status) {
                projection.alias = "_Status";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedBy) {
                projection.alias = "_StatusUpdatedBy";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedDate) {
                projection.alias = "_StatusUpdatedDate";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessInitiator) {
                projection.alias = "_ProcessInitiator";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.LastUpdateDate) {
                projection.alias = "_LastUpdateDate";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.LastUpdateUser) {
                projection.alias = "_LastUpdateUser";
            } else if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment
                || projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation
                || projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory
                || projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                var column = projection.getExtendedQueryColumn();
                projection.alias = self.getValidAliasNameFromString(column.displayName);
            } else {
                projection.alias = self.getValidAliasNameFromString(self.treeService.getDisplayName(projection.reportDataTreeItem));
            }
            switch (projection.projectionType) {
                case Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property:
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group:
                    projection.alias += "Group";
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Count:
                    projection.alias += "Count";
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Max:
                    projection.alias += "Max";
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Min:
                    projection.alias += "Min";
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Sum:
                    projection.alias += "Sum";
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Avg:
                    projection.alias += "Average";
                    break;
            }
            if (autoSave) {
                self.save(null);
            }
        }

        save(callback: any) {
            var self = this;
            self.objectQueryService.saveAllChanges(() => {
                if (callback != null) {
                    callback();    
                }
            });
        }

        deleteProjection(projection: models.ObjectQueryProjection) {
            var self = this;
            var objectQuery = projection.myObjectQuery;
            projection.entityAspect.setDeleted();
            self.save(() => {
                self.filterValidPropertyTypes(objectQuery);
                self.filterValidProjectionTypes(objectQuery);
                self.reorder(objectQuery);
            });
        }

        saveExtendedColumn(projection: models.ObjectQueryProjection) {
            var self = this;
            var column = projection.getExtendedQueryColumn();
            projection.reportDataSubTableColumnName = column.column;
            projection.reportDataSubTableSystemColumnName = column.systemColumn;
            self.save(null);
        }

        setCustomTransformer(objectQuery: Wars.Domain.Model.ObjectQuery) {
            var self = this;
            self.save(null);
        }
        
        changeOrder(projection: models.ObjectQueryProjection, promote: boolean) {
            var self = this;
            var next = Enumerable
                .from(projection.myObjectQuery.projections)
                .where(i => promote ? i.orderNumerator < projection.orderNumerator : i.orderNumerator > projection.orderNumerator)
                .toArray();
            if (next.length === 0) return;
            if (promote) {
                next = Enumerable
                    .from(next)
                    .orderByDescending(i => i.orderNumerator)
                    .toArray();
            } else {
                next = Enumerable
                    .from(next)
                    .orderBy(i => i.orderNumerator)
                    .toArray();
            }
            var flip = next[0].orderNumerator;
            next[0].orderNumerator = projection.orderNumerator;
            projection.orderNumerator = flip;
            self.reorder(projection.myObjectQuery);
        }

        private loadSubQueries(): void {
            var self = this;
            var subqueries = new Array<Wars.Domain.Model.ObjectQuery>();
            var processIdSubqueries = new Array<Wars.Domain.Model.ObjectQuery>();
            var i: number;
            for (i = 0; i < self.existingObjectQueries.length; i++) {
                if (!self.existingObjectQueries[i].isExecutable) continue;
                if (self.existingObjectQueries[i].projections.length !== 1) continue;
                if (self.existingObjectQueries[i].projections[0].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.RowId) {
                    //we have a valid object query sub-query candidate
                    subqueries.push(self.existingObjectQueries[i]);    
                }
                if (self.existingObjectQueries[i].projections[0].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId) {
                    //we have a valid object query sub-query candidate
                    processIdSubqueries.push(self.existingObjectQueries[i]);
                }
            }
            self.objectQueryService.subQueries = subqueries;
            self.objectQueryService.processIdSubQueries = processIdSubqueries;
        }
        
        private reorder(objectQuery: Wars.Domain.Model.ObjectQuery) {
            var self = this;
            var l = Enumerable
                .from(objectQuery.projections)
                .orderBy(i => i.orderNumerator)
                .toArray();
            for (var x = 0; x < l.length; x++) {
                l[x].orderNumerator = x + 1;
            }
            self.save(null);
        }
        
        private loadAllObjectQueries(): void {
            var self = this;
            if (self.processConfigurationId) {
                self.objectQueryService.getAllObjectQueriesForProcessConfiguration(self.processConfigurationId).then(
                (objectQueries) => {
                    self.existingObjectQueries = objectQueries;
                    self.loadSubQueries();
                    for (var i = 0; i < self.existingObjectQueries.length; i++) {
                        self.filterValidPropertyTypes(self.existingObjectQueries[i]);
                        self.filterValidProjectionTypes(self.existingObjectQueries[i]);
                        self.watchObjectQueryExecutionStatus(self.existingObjectQueries[i]);
                    }
                    self.setTransformers();
                });
            } else {
                self.objectQueryService.getAllObjectQueriesForSystemLevel().then(
                (objectQueries) => {
                    self.existingObjectQueries = objectQueries;
                    self.loadSubQueries();
                    for (var i = 0; i < self.existingObjectQueries.length; i++) {
                        self.filterValidPropertyTypes(self.existingObjectQueries[i]);
                        self.filterValidProjectionTypes(self.existingObjectQueries[i]);
                        self.watchObjectQueryExecutionStatus(self.existingObjectQueries[i]);
                    }
                    self.setTransformers();
                });
            }
        }

        private setTransformers() {
            var self = this;
            self.objectQueryService.getCustomTransformers()
                .then((result) => {
                    for (var i = 0; i < self.existingObjectQueries.length; i++) {
                        (<any>self.existingObjectQueries[i]).customTransformers = result;
                    }
                });
        }

        private watchObjectQueryExecutionStatus(objectQuery: Wars.Domain.Model.ObjectQuery) {
            var self = this;
            self.scope.$watch<boolean>(() => { return objectQuery.isExecutable },
                (nv, ov) => {
                    if (ov && nv === false) {
                        for (var i = 0; i < self.existingObjectQueries.length; i++) {
                            for (var j = 0; j < self.existingObjectQueries[i].restrictions.length; j++) {
                                if (self.existingObjectQueries[i].restrictions[j].restrictionType !== "P") continue;
                                var predicate = <models.ObjectQueryPredicate>self.existingObjectQueries[i].restrictions[j];
                                if (predicate.subObjectQuery === null) continue; 
                                if (predicate.subObjectQuery.id !== objectQuery.id) continue;
                                self.objectQueryService.removeSubQuery(objectQuery.id);
                                self.objectQueryService.removeProcessIdSubQuery(objectQuery.id);
                                predicate.subObjectQuery = null;
                                predicate.subObjectQuery_id = null;
                                self.existingObjectQueries[i].isExecutable = false;
                            }
                        }
                    }
                    self.save(null);
                });
        }
        
        private filterValidProjectionTypes(objectQuery: Wars.Domain.Model.ObjectQuery) {
            var self = this;
            var hasAggregaate = Enumerable.from(objectQuery.projections).any(x => x.projectionType !== Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group);
            for (var i = 0; i < objectQuery.projections.length; i++) {
                var projection = (<models.ObjectQueryProjection>objectQuery.projections[i]);
                projection.projectionTypeContext.removeSpecifiedOptions = [];
                if (self.objectQueryService.isAggregateQuery(objectQuery)) {
                    projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property);
                    if (hasAggregaate) {
                        if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group) {
                            projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Count);
                            projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Max);
                            projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Min);
                            projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Sum);
                            projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Avg);
                        }
                    } 
                    if (projection.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property) {
                        projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Max);
                        projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Min);
                        projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Sum);
                        projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Avg);
                    } else {
                        if (projection.reportDataTreeItem != null) {
                            //group and count only
                            if (projection.reportDataTreeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.String ||
                                projection.reportDataTreeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Boolean ||
                                projection.reportDataTreeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Code) {
                                projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Max);
                                projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Min);
                                projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Sum);
                                projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Avg);
                            }
                            //group, count, min, and max only
                            if (projection.reportDataTreeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Date ||
                                projection.reportDataTreeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime ||
                                projection.reportDataTreeItem.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Time) {
                                projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Sum);
                                projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Avg);
                            }    
                        }
                    }
                } else {
                    projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group);
                    projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Count);
                    projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Max);
                    projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Min);
                    projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Sum);
                    projection.projectionTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Avg);
                }    
            }
        }

        private filterExtensionProperties(projection: models.ObjectQueryProjection) {
            var self = this;
            var states = self.objectQueryService.getStates();
            var statuses = self.objectQueryService.getStatuses();
            var processTypes = self.objectQueryService.getProcessTypes();
            var processSubTypes = self.objectQueryService.getProcessSubTypes();
            var reviewConfigurations = self.objectQueryService.getReviewConfigurations();
            var assignmentClaims = self.objectQueryService.getClaims();
            if (statuses == null || statuses.length === 0) {
                projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory);
                projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Status);
            }
            if (states == null || states.length === 0) {
                projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.State);
            }
            var isAggregateQuery = self.objectQueryService.isAggregateQuery(projection.myObjectQuery);
            if (processTypes == null || processTypes.length === 0 || !isAggregateQuery) {
                projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessType);
            }
            if (processSubTypes == null || processSubTypes.length === 0) {
                projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessSubType);
            }
            if (reviewConfigurations == null || reviewConfigurations.length === 0) {
                projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation);
            }
            if (assignmentClaims == null || assignmentClaims.length === 0) {
                projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment);
            }
        }

        private filterValidPropertyTypes(objectQuery: Wars.Domain.Model.ObjectQuery) {
            var self = this;
            var i: number;
            var projection: models.ObjectQueryProjection;
            if (self.objectQueryService.isAggregateQuery(objectQuery)) {
                for (i = 0; i < objectQuery.projections.length; i++) {
                    projection = (<models.ObjectQueryProjection>objectQuery.projections[i]);
                    projection.propertyTypeContext.removeSpecifiedOptions = [];
                    if (self.processConfigurationId != null) {
                        projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessType);
                    }  
                    self.filterExtensionProperties(projection);  
                }
                (<any>objectQuery).canAddProjection = true;
                return;
            }
            var hasRowId = Enumerable.from(objectQuery.projections).any(x => x.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.RowId);
            var hasProcessId = Enumerable.from(objectQuery.projections).any(x => x.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId);
            if (objectQuery.projections.length === 0) {
                (<any>objectQuery).canAddProjection = true;
                return;
            }
            for (i = 0; i < objectQuery.projections.length; i++) {
                projection = (<models.ObjectQueryProjection>objectQuery.projections[i]);
                (<any>objectQuery).canAddProjection = projection.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.RowId && projection.propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId;
                projection.propertyTypeContext.removeSpecifiedOptions = [];
                if (self.processConfigurationId != null) {
                    projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessType);    
                }
                if (self.objectQueryService.getStates().length === 0) {
                    projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Status);
                    projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.State);
                }
            }
            if (objectQuery.projections.length > 1) {
                for (i = 0; i < objectQuery.projections.length; i++) {
                    projection = (<models.ObjectQueryProjection>objectQuery.projections[i]);
                    projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.RowId);
                    projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId);
                }   
            }
            for (i = 0; i < objectQuery.projections.length; i++) {
                projection = (<models.ObjectQueryProjection>objectQuery.projections[i]);
                if (hasRowId && objectQuery.projections[i].propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.RowId) {
                    projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.RowId);
                }
                if (hasProcessId && objectQuery.projections[i].propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId) {
                    projection.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId);
                }
                self.filterExtensionProperties(projection);
            }
        }

        private saveNewObjectQuery(newObjectQuery: Wars.Domain.Model.ObjectQuery): void {
            var self = this;
            self.save(() => {
                self.existingObjectQueries.push(newObjectQuery);
                self.newObjectQueryName = "";
            });
        }

        deleteObjectQuery(objectQuery: Wars.Domain.Model.ObjectQuery) {
            var self = this;
            self.objectQueryService.deleteObjectQuery(objectQuery)
                .then(() => {
                        self.existingObjectQueries = Enumerable.from(self.existingObjectQueries)
                            .where(i => i.id !== objectQuery.id)
                            .toArray();
                        self.growlService.info(`Object Query [${objectQuery.name}] was deleted`);
                    },
                    (result: Wars.Domain.Model.Dtos.Delete.DeleteResult) => {
                        for (var x = 0; x < result.conflictInfo.conflictMessages.length; x++) {
                            self.growlService.error(result.conflictInfo.conflictMessages[x]);
                        }
                    });
        }

        testExecution(objectQuery: Wars.Domain.Model.ObjectQuery) {
            var self = this;
            self.objectQueryService.testExecution(objectQuery)
                .then((result) => {
                    if (!objectQuery.compressResult) {
                        (<any>objectQuery).results = JSON.stringify(JSON.parse(result), null, "\t");
                        return;
                    }    
                    // Decode base64 (convert ascii to binary)
                    var strData = atob(result);
                    // Convert binary string to character-number array
                    var charData = strData.split("").map((x) => { return x.charCodeAt(0); });
                    // Turn number array into byte-array
                    var binData = new Uint8Array(charData);
                    // Pako magic
                    var data = pako.inflate(binData);
                    // convert to unsigned 16 bit
                    var arr = new Uint16Array(data);
                    // Convert gunzipped byteArray back to ascii string:
                    var json = [];
                    var objectEndFound = false;
                    var objectDeserialized = 0;
                    //process in reverse to remove the variable byte order markers at the front of the byte array
                    for (var i = arr.length - 1; i > 0; i--) {
                        var char = String.fromCharCode(arr[i]);
                        if (char === "]") {
                            objectDeserialized += 1;
                        } 
                        if (char === "[") {
                            objectDeserialized -= 1;
                        }
                        if (objectDeserialized === 0 && !objectEndFound) continue;
                        json.push(char);
                        objectEndFound = true;
                        if (objectDeserialized === 0) break;
                    }
                    //reverse the array and parse the object
                    json = json.reverse();
                    (<any>objectQuery).results = JSON.stringify(JSON.parse(json.join("")), null, "\t");
                });
        }
        
        compile(objectQuery: Wars.Domain.Model.ObjectQuery) {
            var self = this;
            (<any>objectQuery).results = null;
            self.objectQueryService.onObjectQueryModified(objectQuery);
            var i: number;
            //set defaults for any missing projection alias names
            for (i = 0; i < objectQuery.projections.length; i++) {
                if (objectQuery.projections[i].alias == null || objectQuery.projections[i].alias.trim() === "") {
                    self.setDefaultAliasName(<models.ObjectQueryProjection>objectQuery.projections[i], false);
                }
            }
            //set defaults for any missing parameter names
            var parameters = new Array<ObjectQueryPredicate>();
            var restrictions = objectQuery.restrictions;
            if (restrictions && restrictions.length > 0) {
                for (i = 0; i < restrictions.length; i++) {
                    if (restrictions[i].restrictionType === "P"
                        && ((<ObjectQueryPredicate>restrictions[i]).rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.InputParameterValue
                            || (<ObjectQueryPredicate>restrictions[i]).rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.InputParameterList)) {
                        //process initiator is not an input parameter
                        //if ((<ObjectQueryPredicate>restrictions[i]).propertyType !== Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessInitiator) {
                            parameters.push((<ObjectQueryPredicate>restrictions[i]));
                        //}

                        if ((<ObjectQueryPredicate>restrictions[i]).parameterName === null || (<ObjectQueryPredicate>restrictions[i]).parameterName.trim() === "") {
                            self.setDefaultParameterName((<ObjectQueryPredicate>restrictions[i]));
                        }     
                    }
                }    
            }
            var projections = new Array<ObjectQueryProjection>();
            for (i = 0; i < objectQuery.projections.length; i++) {
                projections.push(<ObjectQueryProjection>objectQuery.projections[i]);
            }
            self.save(() => {
                //validate query
                self.validateObjectQuery(objectQuery).then((messages) => {
                    if (messages != null && messages.length > 0) {
                        self.growlService.error(Enumerable.from(messages).aggregate((p, c) => `${p}<br><br>${c}`));
                        return;
                    }
                    //build input object schema
                    var genOutputSchema = (<any>objectQuery).genOutputSchema ? true : false;
                    var genInputSchema = (<any>objectQuery).genInputSchema ? true : false;
                    var genSchemas = objectQuery.myProjectionObjectSchema == null || genInputSchema || genOutputSchema;
                    
                    if (!genSchemas) {
                        objectQuery.isExecutable = true;
                        self.save(() => {});
                        return;
                    }

                    self.genInputSchema(objectQuery, parameters, genInputSchema).then(() => {
                        self.genOutputSchema(objectQuery, projections, genOutputSchema).then(() => {
                            objectQuery.isExecutable = true;
                            self.save(() => {
                                self.loadSubQueries();
                                (<any>objectQuery).genOutputSchema = false;
                                (<any>objectQuery).genInputSchema = false;
                            });
                        });
                    });

                    
                    //var oldInputSchema = objectQuery.myInputObjectSchema;
                    //var oldOutputSchema = objectQuery.myProjectionObjectSchema;
                    //self.setInputObjectSchema(parameters).then((inputSchema) => {
                    //    //build projection object schema
                    //    self.setProjectionObjectSchema(projections).then((projectionSchema) => {
                    //        objectQuery.isExecutable = true;
                    //        //mark query as executable and save
                    //        if (inputSchema != null) {
                    //            objectQuery.inputObjectSchema_id = inputSchema.id;
                    //            objectQuery.myInputObjectSchema = inputSchema;
                    //        }
                    //        if (projectionSchema != null) {
                    //            objectQuery.projectionObjectSchema_id = projectionSchema.id;
                    //            objectQuery.myProjectionObjectSchema = projectionSchema;
                    //        }
                    //        self.save(() => {
                    //            if (oldOutputSchema != null) {
                    //                self.objectQueryService.deleteObjectSchema(oldOutputSchema).then(() => {
                    //                    if (oldInputSchema != null) {
                    //                        self.objectQueryService.deleteObjectSchema(oldInputSchema);
                    //                    }
                    //                });
                    //            }
                    //            self.loadSubQueries();
                    //        });
                    //    });
                    //});    

                });
            });
        }

        
        private genOutputSchema(objectQuery: Wars.Domain.Model.ObjectQuery, projections: ObjectQueryProjection[],  gen: boolean): angular.IPromise<any> {
            var self = this;
            var d = self.qService.defer();
            if (gen) {
                var oldOutputSchema = objectQuery.myProjectionObjectSchema;
                self.setProjectionObjectSchema(projections).then((projectionSchema) => {
                        if (projectionSchema != null) {
                            objectQuery.projectionObjectSchema_id = projectionSchema.id;
                            objectQuery.myProjectionObjectSchema = projectionSchema;
                        }
                        self.save(() => {
                            if (oldOutputSchema != null) {
                                self.objectQueryService.deleteObjectSchema(oldOutputSchema).then(() => {
                                    d.resolve();
                                });
                            } else {
                                d.resolve();
                            }
                        });
                    });
            } else {
                d.resolve();
            }
            return d.promise;
        }

        private genInputSchema(objectQuery: Wars.Domain.Model.ObjectQuery, parameters: ObjectQueryPredicate[], gen: boolean): angular.IPromise<any> {
            var self = this;
            var d = self.qService.defer();
            if (gen) {
                var oldInputSchema = objectQuery.myInputObjectSchema;
                self.setInputObjectSchema(parameters).then((inputSchema) => {
                    if (inputSchema != null) {
                        objectQuery.inputObjectSchema_id = inputSchema.id;
                        objectQuery.myInputObjectSchema = inputSchema;
                    }
                    self.save(() => {
                        if (oldInputSchema != null) {
                            self.objectQueryService.deleteObjectSchema(oldInputSchema).then(() => {
                                d.resolve();
                            });
                        } else {
                            d.resolve();
                        }
                    });
                });
            } else {
                d.resolve();
            }
            return d.promise;
        }
        

        private setDefaultParameterName(restriction: models.ObjectQueryPredicate) {
            //var self = this;
            //if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property) {
            //    restriction.parameterName = self.getTreeItemName(restriction.leftReportDataTreeItem);
            //} else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.State) {
            //    restriction.parameterName = "[Current State]";
            //} else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Status) {
            //    restriction.parameterName = "[Current Status]";
            //} else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessType) {
            //    restriction.parameterName = "[Process Type]";
            //} else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessSubType) {
            //    restriction.parameterName = "[Process Sub-Type]";
            //}
            //self.save(null);
            var self = this;
            var column: ExtendedQueryColumn;
            if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property) {
                restriction.parameterName = self.getTreeItemName(restriction.leftReportDataTreeItem);
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.State) {
                restriction.parameterName = "[Current State]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedBy) {
                restriction.parameterName = "[Current State Updated By]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedDate) {
                restriction.parameterName = "[Current State Updated Date]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Status) {
                restriction.parameterName = "[Current Status]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedBy) {
                restriction.parameterName = "[Current Status Updated By]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedDate) {
                restriction.parameterName = "[Current Status Updated Date]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessType) {
                restriction.parameterName = "[Process Type]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessSubType) {
                restriction.parameterName = "[Process Sub-Type]";
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment) {
                column = restriction.getExtendedQueryColumn();
                restriction.parameterName = `[Assignmnet] [${column.displayName}]`;
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation) {
                column = restriction.getExtendedQueryColumn();
                restriction.parameterName = `[Review Information] [${column.displayName}]`;
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory) {
                column = restriction.getExtendedQueryColumn();
                restriction.parameterName = `[Status History] [${column.displayName}]`;
            } else if (restriction.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                column = restriction.getExtendedQueryColumn();
                restriction.parameterName = `[Comment Information] [${column.displayName}]`;
            }
            self.save(null);
        }

        private validateObjectQuery(objectQuery: Wars.Domain.Model.ObjectQuery): angular.IPromise<Array<string>> {
            var self = this;
            var d = self.qService.defer();
            var messages = new Array<string>();
            var projections = objectQuery.projections;
            if (projections.length === 0) {
                messages.push("At least one projection is required in an object query.");
            }
            var i: number;
            for (i = 0; i < projections.length; i++) {
                if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property
                    && projections[i].reportDataTreeItem_id === null) {
                    messages.push("All projections must specify a property.");
                    break;
                }
            }
            for (i = 0; i < projections.length; i++) {
                if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property) {
                    var c = Enumerable.from(objectQuery.projections)
                        .where(x => x.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property)
                        .where(x => x.alias.toLowerCase() === projections[i].alias.toLowerCase())
                        .count();
                    if (c > 1) {
                        messages.push("All projection alias names must be unique - case insensitive.");
                        break;        
                    }
                }
            }
            var restrictions = objectQuery.restrictions;
            if (restrictions.length === 0) {
                messages.push("At least one restriction is required in an object query.");
            }
            var hasSubGroupMessage = false;
            var hasLeftPredicateRequiredMessage = false;
            var hasRightPredicateRequiredMessage = false;
            var hasSubQueryPredicateRequiredMessage = false;
            for (i = 0; i < restrictions.length; i++) {
                if (restrictions[i].restrictionType !== "P") {
                    var children = Enumerable.from(restrictions).where(x => x.myParentRestriction !== null && x.myParentRestriction.id === restrictions[i].id).count();
                    if (children < 2) {
                        if (!hasSubGroupMessage) {
                            messages.push("All And and Or junctions must contain at least 2 predicates.");
                            hasSubGroupMessage = true;
                        }
                    }
                } else {
                    if ((<ObjectQueryPredicate>restrictions[i]).propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property
                        && (<ObjectQueryPredicate>restrictions[i]).leftReportDataTreeItem === null) {
                        if (!hasLeftPredicateRequiredMessage) {
                            messages.push("All predicates must specify a left-side property.");
                            hasLeftPredicateRequiredMessage = true;
                        }
                    }
                    if (((<ObjectQueryPredicate>restrictions[i]).rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.Constant
                        || (<ObjectQueryPredicate>restrictions[i]).rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.PlaceHolder
                        || (<ObjectQueryPredicate>restrictions[i]).rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.Calculation
                        || (<ObjectQueryPredicate>restrictions[i]).rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.Property)
                        && (<ObjectQueryPredicate>restrictions[i]).rightParameterTreeItem === null) {
                        if (!hasRightPredicateRequiredMessage) {
                            messages.push("All constant, placeholder, and property predicate types must be specified.");
                            hasRightPredicateRequiredMessage = true;
                        }
                    }
                    if ((<ObjectQueryPredicate>restrictions[i]).rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.SubQuery
                        && ((<ObjectQueryPredicate>restrictions[i]).propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.RowId || (<ObjectQueryPredicate>restrictions[i]).propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId)
                        && (<ObjectQueryPredicate>restrictions[i]).subObjectQuery_id === null) {
                        if (!hasSubQueryPredicateRequiredMessage) {
                            messages.push("All sub-query predicates must specify a valid sub-query.");
                            hasSubQueryPredicateRequiredMessage = true;
                        }
                    }
                }
            }
            d.resolve(messages);
            return d.promise;
        }

        private setInputObjectSchema(parameters: Array<ObjectQueryPredicate>): angular.IPromise<Wars.Domain.Model.ObjectSchema> {
            var self = this;
            var d = self.qService.defer();
            if (parameters.length === 0) {
                d.resolve(null);
                return d.promise;
            }
            var objectQuery = parameters[0].myObjectQuery;
            var schema = self.objectQueryService.createNewInputSchema(objectQuery);
            var listSchemas = new Array<Wars.Domain.Model.ObjectSchema>();
            var listSchemaParentProperties = new Array<Wars.Domain.Model.SchemaProperty>();
            var i: number;
            for (i = 0; i < parameters.length; i++) {
                var property = self.objectQueryService.createNewSchemaProperty(schema);
                self.setInputSchemaPropertyBaseValues(parameters[i], property);
                if (parameters[i].rightRestrictionType === Wars.Domain.Model.Codes.Enums.ObjectQueryRightRestrictionType.InputParameterList) {
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Object;
                    var listSchema = self.objectQueryService.createNewInputListSchema(objectQuery, schema, property.name);
                    property.typeSchema = listSchema;
                    property.type_id = listSchema.id;
                    listSchemas.push(listSchema);
                    listSchemaParentProperties.push(property);
                    var listProperty = self.objectQueryService.createNewSchemaProperty(listSchema);
                    self.setInputSchemaPropertyBaseValues(parameters[i], listProperty);
                    self.setInputSchemaPropertyType(parameters[i], listProperty);
                    self.setSchemaPropertyCodeGroup(parameters[i], listProperty);    
                } else {
                    self.setInputSchemaPropertyType(parameters[i], property);
                    self.setSchemaPropertyCodeGroup(parameters[i], property);
                }
            }
            self.save(() => {
                //relate list object schema parent properties after the initial save - Breeze can only save a double-sided many-to-many unidirectionally in a single save
                for (i = 0; i < listSchemas.length; i++) {
                    listSchemas[i].parentProperty = listSchemaParentProperties[i];
                    listSchemas[i].schemaProperty_id = listSchemaParentProperties[i].id;
                }
                d.resolve(schema);    
            });
            return d.promise;
        }

        private setInputSchemaPropertyBaseValues(predicate: ObjectQueryPredicate, property: Wars.Domain.Model.SchemaProperty) {
            var self = this;
            property.name = predicate.parameterName;
            predicate.parameterSchemaPropertyUniqueId = property.uniqueIdentifier;
            property.isIndexed = false;
            property.required = true;
            property.isSystemLevel = self.processConfigurationId == null;
        }

        private setProjectionSchemaPropertyBaseValues(projection: ObjectQueryProjection, property: Wars.Domain.Model.SchemaProperty) {
            var self = this;
            property.name = projection.alias;
            property.isIndexed = false;
            property.required = false;
            property.isSystemLevel = self.processConfigurationId == null;
        }

        private setSchemaPropertyCodeGroup(predicate: ObjectQueryPredicate, property: Wars.Domain.Model.SchemaProperty) {
            if (predicate.leftReportDataTreeItem == null) return;
            if (predicate.leftReportDataTreeItem.schemaProperty == null) return;
            if (predicate.leftReportDataTreeItem.schemaProperty.codeGroup_id == null) return;
            property.codeGroup = predicate.leftReportDataTreeItem.schemaProperty.codeGroup;
            property.codeGroup_id = predicate.leftReportDataTreeItem.schemaProperty.codeGroup_id;
        }

        private setInputSchemaPropertyType(predicate: ObjectQueryPredicate, property: Wars.Domain.Model.SchemaProperty) {
            switch (predicate.propertyType) {
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property:
                    property.propertyType = predicate.leftReportDataTreeItem.variableType;
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.State:
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.State;
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedBy:
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.User;
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedDate:
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.DateTime;
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Status:
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Status;
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedBy:
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.User;
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedDate:
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.DateTime;
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.RowId:
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Identifier;
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId:
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.ProcessId;
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessType:
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.ProcessType;
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessSubType:
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.SubType;
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessInitiator:
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.User;
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment:
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation:
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory:
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation:
                    var column = predicate.getExtendedQueryColumn();
                    switch (column.dataType) {
                        case ExtendedQueryColumnDataType.State:
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.State;
                            break;
                        case ExtendedQueryColumnDataType.User:
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.User;
                            break;
                        case ExtendedQueryColumnDataType.UserEmail:
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.UserEmail;
                            break;
                        case ExtendedQueryColumnDataType.Boolean:
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Boolean;
                            break;
                        case ExtendedQueryColumnDataType.Claim:
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Claim;
                            break;
                        case ExtendedQueryColumnDataType.Date:
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Date;
                            break;
                        case ExtendedQueryColumnDataType.Number:
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Decimal;
                            break;
                        case ExtendedQueryColumnDataType.ReviewConfiguration:
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.ReviewConfiguration;
                            break;
                        case ExtendedQueryColumnDataType.ReviewType:
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.ReviewType;
                            break;
                        case ExtendedQueryColumnDataType.Status:
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Status;
                            break;
                        case ExtendedQueryColumnDataType.String:
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                            break;
                    }
                    break;
            }
        }

        private setProjectionSchemaPropertyType(projection: ObjectQueryProjection, property: Wars.Domain.Model.SchemaProperty) {
            switch (projection.propertyType) {
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property:
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation:
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment:
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory:
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessInitiator:
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation:
                    var variableType: Wars.Domain.Model.Codes.Enums.VariableType;
                    if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property) {
                        variableType = projection.reportDataTreeItem.variableType;    
                    }
                    if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessInitiator) {
                        variableType = Wars.Domain.Model.Codes.Enums.VariableType.User;
                    }
                    if (projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment
                        || projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation
                        || projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory
                        || projection.propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                        var column = projection.getExtendedQueryColumn();
                        switch (column.dataType) {
                            case ExtendedQueryColumnDataType.State:
                                variableType = Wars.Domain.Model.Codes.Enums.VariableType.State;
                                break;
                            case ExtendedQueryColumnDataType.User:
                                variableType = Wars.Domain.Model.Codes.Enums.VariableType.User;
                                break;
                            case ExtendedQueryColumnDataType.UserEmail:
                                variableType = Wars.Domain.Model.Codes.Enums.VariableType.UserEmail;
                                break;
                            case ExtendedQueryColumnDataType.Boolean:
                                variableType = Wars.Domain.Model.Codes.Enums.VariableType.Boolean;
                                break;
                            case ExtendedQueryColumnDataType.Claim:
                                variableType = Wars.Domain.Model.Codes.Enums.VariableType.Claim;
                                break;
                            case ExtendedQueryColumnDataType.Date:
                                variableType = Wars.Domain.Model.Codes.Enums.VariableType.Date;
                                break;
                            case ExtendedQueryColumnDataType.Number:
                                variableType = Wars.Domain.Model.Codes.Enums.VariableType.Decimal;
                                break;
                            case ExtendedQueryColumnDataType.ReviewConfiguration:
                                variableType = Wars.Domain.Model.Codes.Enums.VariableType.ReviewConfiguration;
                                break;
                            case ExtendedQueryColumnDataType.ReviewType:
                                variableType = Wars.Domain.Model.Codes.Enums.VariableType.ReviewType;
                                break;
                            case ExtendedQueryColumnDataType.Status:
                                variableType = Wars.Domain.Model.Codes.Enums.VariableType.Status;
                                break;
                            case ExtendedQueryColumnDataType.String:
                                variableType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                                break;
                        }
                    }
                    if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group
                        || projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property) {
                        switch (variableType) {
                            case Wars.Domain.Model.Codes.Enums.VariableType.Boolean:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Boolean;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.Code:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.Date:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Date;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.DateTime:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.DateTime;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.Decimal:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Decimal;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.Integer:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.String:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.Time:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Time;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.User:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.UserEmail:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.Claim:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.State:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.Status:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.ReviewType:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.ReviewConfiguration:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.ProcessId:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.TimeTracker:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.TimeTracker;
                                break;
                        }
                    } else if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Avg) {
                        switch (variableType) {
                            case Wars.Domain.Model.Codes.Enums.VariableType.Decimal:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Decimal;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.Integer:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Decimal;
                                break;
                        }

                    } else if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Sum) {
                        switch (variableType) {
                            case Wars.Domain.Model.Codes.Enums.VariableType.Decimal:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Decimal;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.Integer:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                                break;
                        }
                    } else if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Max
                        || projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Min) {
                        switch (variableType) {
                            case Wars.Domain.Model.Codes.Enums.VariableType.Decimal:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Decimal;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.Integer:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.Date:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Date;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.DateTime:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.DateTime;
                                break;
                            case Wars.Domain.Model.Codes.Enums.VariableType.Time:
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Time;
                                break;
                        }
                    }
                    else {
                        //count
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                    }
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.State:
                    if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group
                        || projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property) {
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                    } else {
                        //count
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                    }
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedBy:
                    if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group
                        || projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property) {
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                    } else {
                        //count
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                    }
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StateLastUpdatedDate:
                    if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group
                        || projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property) {
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.DateTime;
                    } else {
                        //count
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                    }
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Status:
                    if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group
                        || projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property) {
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                    } else {
                        //count
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                    }
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedBy:
                    if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group
                        || projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property) {
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                    } else {
                        //count
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                    }
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusLastUpdatedDate:
                    if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group
                        || projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property) {
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.DateTime;
                    } else {
                        //count
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                    }
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.RowId:
                    if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group
                        || projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property) {
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Identifier;
                    } else {
                        //count
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                    }
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId:
                    if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group
                        || projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property) {
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.ProcessId;
                    } else {
                        //count
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                    }
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessType:
                    if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group
                        || projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property) {
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                    } else {
                        //count
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                    }
                    break;
                case Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessSubType:
                    if (projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Group
                        || projection.projectionType === Wars.Domain.Model.Codes.Enums.ObjectQueryProjectionType.Property) {
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                    } else {
                        //count
                        property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                    }
                    break;
            }
        }

        private setProjectionObjectSchema(projections: Array<ObjectQueryProjection>): angular.IPromise<Wars.Domain.Model.ObjectSchema> {
            var self = this;
            var d = self.qService.defer();
            if (projections.length === 0) {
                d.resolve(null);
                return d.promise;
            }
            var objectQuery = projections[0].myObjectQuery;
            var schema = self.objectQueryService.createProjectionSchema(objectQuery);
            var isAggregateQuery = self.objectQueryService.isAggregateQuery(objectQuery);
            var isRowIdQuery = projections.length === 1 && projections[0].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.RowId;
            var isProcessIdQuery = projections.length === 1 && projections[0].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId;
            var listSchemas = new Array<Wars.Domain.Model.ObjectSchema>();
            var listSchemaParentProperties = new Array<Wars.Domain.Model.SchemaProperty>();
            var listName: string;
            var n: string;
            var property: Wars.Domain.Model.SchemaProperty;
            var i: number;
            if (!isAggregateQuery && !isRowIdQuery && !isProcessIdQuery) {
                var impliedProperty: Wars.Domain.Model.SchemaProperty;
                //add any list object schemas
                for (i = 0; i < projections.length; i++) {
                    var listSchema: Wars.Domain.Model.ObjectSchema = null;
                    var exists: boolean = false;
                    if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property) {
                        if (projections[i].reportDataTreeItem.itemSource === Wars.Domain.Model.Codes.Enums.TreeItemSource.TimeTracker) continue;
                        if (projections[i].reportDataTreeItem.schemaProperty.parentObjectSchema == null || !projections[i].reportDataTreeItem.schemaProperty.parentObjectSchema.isList) continue;
                        //TODO: Randy - temp fix to handle null name on list schema property's parent object schema 
                        //listName = self.getValidAliasNameFromString(projections[i].reportDataTreeItem.schemaProperty.parentObjectSchema.name);
                        n = projections[i].reportDataTreeItem.schemaProperty.parentObjectSchema.name;
                        if (n == null) {
                            n = projections[i].reportDataTreeItem.schemaProperty.parentObjectSchema.parentProperty.name;
                        }
                        listName = self.getValidAliasNameFromString(n);
                        //end
                        exists = Enumerable.from(listSchemas).any(x => x.name === listName);
                        if (exists) continue;
                        listSchema = self.objectQueryService.createNewProjectionListSchema(objectQuery, schema, listName);
                        listSchemas.push(listSchema);    
                    }
                    if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment
                        || projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation
                        || projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory
                        || projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                        if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment) {
                            listName = projections[i].assignmentQueryMap.listName;
                        }
                        if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation) {
                            listName = projections[i].reviewInformationQueryMap.listName;
                        }
                        if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory) {
                            listName = projections[i].statusHistoryQueryMap.listName;
                        }
                        if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                            listName = projections[i].commentInformationQueryMap.listName;
                        }
                        exists = Enumerable.from(listSchemas).any(x => x.name === listName);
                        if (exists) continue;
                        listSchema = self.objectQueryService.createNewProjectionListSchema(objectQuery, schema, listName);
                        listSchemas.push(listSchema);
                    }
                    if (listSchema == null) continue;
                    property = self.objectQueryService.createNewSchemaProperty(schema);
                    property.name = listName;
                    property.isIndexed = false;
                    property.required = false;
                    property.isSystemLevel = self.processConfigurationId == null;
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Object;
                    property.typeSchema = listSchema;
                    property.type_id = listSchema.id;
                    listSchemaParentProperties.push(property);
                    if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property
                        || projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment
                        || projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation
                        || projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory
                        || projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                        //add _Id property for each list projection
                        impliedProperty = self.objectQueryService.createNewSchemaProperty(listSchema);
                        impliedProperty.name = "_Id";
                        impliedProperty.isIndexed = false;
                        impliedProperty.required = false;
                        impliedProperty.isSystemLevel = self.processConfigurationId == null;
                        impliedProperty.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Identifier;    
                    }
                }  
                //add implied properties for non-aggrgate queries
                //_Id
                impliedProperty = self.objectQueryService.createNewSchemaProperty(schema);
                impliedProperty.name = "_Id";
                impliedProperty.isIndexed = false;
                impliedProperty.required = false;
                impliedProperty.isSystemLevel = self.processConfigurationId == null;
                impliedProperty.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Identifier;
                //_ProcessId
                impliedProperty = self.objectQueryService.createNewSchemaProperty(schema);
                impliedProperty.name = "_ProcessId";
                impliedProperty.isIndexed = false;
                impliedProperty.required = false;
                impliedProperty.isSystemLevel = self.processConfigurationId == null;
                impliedProperty.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.ProcessId;
                //_ProcessType
                impliedProperty = self.objectQueryService.createNewSchemaProperty(schema);
                impliedProperty.name = "_ProcessType";
                impliedProperty.isIndexed = false;
                impliedProperty.required = false;
                impliedProperty.isSystemLevel = self.processConfigurationId == null;
                impliedProperty.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                //_ProcessTypeId
                impliedProperty = self.objectQueryService.createNewSchemaProperty(schema);
                impliedProperty.name = "_ProcessTypeId";
                impliedProperty.isIndexed = false;
                impliedProperty.required = false;
                impliedProperty.isSystemLevel = self.processConfigurationId == null;
                impliedProperty.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.ProcessType;
                //_LastUpdateDate
                impliedProperty = self.objectQueryService.createNewSchemaProperty(schema);
                impliedProperty.name = "_LastUpdateDate";
                impliedProperty.isIndexed = false;
                impliedProperty.required = false;
                impliedProperty.isSystemLevel = self.processConfigurationId == null;
                impliedProperty.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.DateTime;
                //_LastUpdateUser
                impliedProperty = self.objectQueryService.createNewSchemaProperty(schema);
                impliedProperty.name = "_LastUpdateUser";
                impliedProperty.isIndexed = false;
                impliedProperty.required = false;
                impliedProperty.isSystemLevel = self.processConfigurationId == null;
                impliedProperty.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.User;
            }
            for (i = 0; i < projections.length; i++) {
                var addRootSchemaProperty = false;
                if (isAggregateQuery) {
                    addRootSchemaProperty = true;
                } else {
                    var listProperty: Wars.Domain.Model.SchemaProperty = null;
                    if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Property) {
                        if (projections[i].reportDataTreeItem.itemSource !== Wars.Domain.Model.Codes.Enums.TreeItemSource.TimeTracker &&
                            projections[i].reportDataTreeItem.schemaProperty.parentObjectSchema != null &&
                            projections[i].reportDataTreeItem.schemaProperty.parentObjectSchema.isList) {
                            //TODO: Randy - temp fix to handle null name on list schema property's parent object schema 
                            //listName = self.getValidAliasNameFromString(projections[i].reportDataTreeItem.schemaProperty.parentObjectSchema.name);
                            n = projections[i].reportDataTreeItem.schemaProperty.parentObjectSchema.name;
                            if (n == null) {
                                n = projections[i].reportDataTreeItem.schemaProperty.parentObjectSchema.parentProperty.name;
                            }
                            listName = self.getValidAliasNameFromString(n);
                            //end
                            listProperty = self.objectQueryService.createNewSchemaProperty(Enumerable.from(listSchemas).first(x => x.name === listName));
                            self.setProjectionSchemaPropertyBaseValues(projections[i], listProperty);
                            self.setProjectionSchemaPropertyType(projections[i], listProperty);
                        } else {
                            addRootSchemaProperty = true;
                        }
                    } else if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment
                        || projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation
                        || projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory
                        || projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                        
                        if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.Assignment) {
                            listName = projections[i].assignmentQueryMap.listName;
                        }
                        if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ReviewInformation) {
                            listName = projections[i].reviewInformationQueryMap.listName;
                        }
                        if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.StatusHistory) {
                            listName = projections[i].statusHistoryQueryMap.listName;
                        }
                        if (projections[i].propertyType === Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.CommentInformation) {
                            listName = projections[i].commentInformationQueryMap.listName;
                        }
                        listProperty = self.objectQueryService.createNewSchemaProperty(Enumerable.from(listSchemas).first(x => x.name === listName));
                        self.setProjectionSchemaPropertyBaseValues(projections[i], listProperty);
                        self.setProjectionSchemaPropertyType(projections[i], listProperty);
                    } else {
                        addRootSchemaProperty = true;
                    }
                }
                if (addRootSchemaProperty) {
                    property = self.objectQueryService.createNewSchemaProperty(schema);
                    self.setProjectionSchemaPropertyBaseValues(projections[i], property);
                    self.setProjectionSchemaPropertyType(projections[i], property);
                }
            }
            self.save(() => {
                //relate list object schema parent properties after the initial save - Breeze can only save a double-sided many-to-many unidirectionally in a single save 
                if (!isAggregateQuery && !isRowIdQuery && !isProcessIdQuery) {
                    for (i = 0; i < listSchemas.length; i++) {
                        listSchemas[i].parentProperty = listSchemaParentProperties[i];
                        listSchemas[i].schemaProperty_id = listSchemaParentProperties[i].id;
                    }    
                }
                d.resolve(schema);
            });
            return d.promise;
        }
    }
}